function setFontSize() {
    var docEl = document.documentElement;
    var clientWidth = docEl.clientWidth;
    var canvasSize = window.canvasSize || 468;
    if (!clientWidth) return;
    if (clientWidth >= canvasSize) {
        if (canvasSize != 468) {
            docEl.style.fontSize = 20 * (canvasSize / 468) + 'px';
        } else {
            docEl.style.fontSize = '20px';
        }
    } else {
        docEl.style.fontSize = 20 * (clientWidth / 468) + 'px';
    }
}

function refreshFontSize() {
    setFontSize();
}

(function (doc, win) {
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, setFontSize, false);
    doc.addEventListener('DOMContentLoaded', setFontSize, false);

    // 返回用于刷新字体大小的函数
    win.refreshFontSize = refreshFontSize;
})(document, window);


// WEBPACK FOOTER //
// ./src/assets/js/js.js